import Component from "@glimmer/component";
import { service } from "@ember/service";
import { task } from "ember-concurrency";
import taskHelper from "ember-concurrency/helpers/task";
import { t } from "ember-intl";
import PageContent from "glesys-controlpanel/components/page-content";
import PageContentServiceIntro from "glesys-controlpanel/components/page-content/service-intro";
import InviteCard from "glesys-controlpanel/components/invite-card";

export default class extends Component {
  @service router;

  get sortedInvites() {
    return this.args.model.slice().sort((a, b) => b.created.localeCompare(a.created));
  }

  acceptTask = task(async (invite) => {
    let organizationId = invite.organizationId;

    await invite.accept();

    if (this.sortedInvites.length === 0) {
      this.router.transitionTo("organization.overview", organizationId);
    }
  });

  <template>
    <PageContent @isCentered={{true}}>
      <PageContentServiceIntro @title={{t "dashboard.invites.page-title"}} />

      {{#if this.sortedInvites.length}}
        {{#each this.sortedInvites as |invite|}}
          <InviteCard
            data-test-invite-card={{invite.id}}
            @invite={{invite}}
            @task={{taskHelper this.acceptTask invite}}
          />
        {{/each}}
      {{else}}
        <p class="text-center text-gray-500 text-sm" data-test-invites-empty>
          {{t "dashboard.invites.empty"}}
        </p>
      {{/if}}
    </PageContent>
  </template>
}
